import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  Popover,
  Toolbar,
  Typography,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import { StyledIconButton } from '../../../constants/styledComponents';

export const HeaderAppBar = styled(AppBar)(({ theme }) => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.common,
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
}));

export const HeaderToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  minHeight: 60,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },

  [theme.breakpoints.up('md')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export const HeaderSidebarButton = styled(StyledIconButton)(({ theme }) => ({
  width: 44,
  height: 40,
  minWidth: 44,
  marginRight: 0,
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const HeaderSpacer = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}));

export const HeaderActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  flexShrink: 0,

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(0.75),
  },
}));

export const HeaderControlsTray = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  height: 48,
  padding: '5px 5px 5px 8px',
  borderRadius: 26,
  backgroundColor:
    theme.palette.mode === 'dark'
      ? alpha(theme.palette.common.white, 0.055)
      : alpha(theme.palette.common.black, 0.035),
  boxShadow:
    theme.palette.mode === 'dark'
      ? `inset 0 0 0 1px ${alpha(theme.palette.common.white, 0.055)}`
      : `inset 0 0 0 1px ${alpha(theme.palette.common.black, 0.035)}`,
  flexShrink: 0,
}));

export const HeaderAvatarButton = styled(IconButton)(({ theme }) => ({
  width: 38,
  height: 38,
  minWidth: 38,
  padding: 0,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '50%',
  boxShadow: `0 1px 3px ${alpha(theme.palette.primary.dark, 0.22)}`,
  flex: 'none',

  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const HeaderAvatar = styled(Avatar)(({ theme }) => ({
  width: 38,
  height: 38,
  color: theme.palette.common.white,
  backgroundColor: 'transparent',
}));

export const UserMenuPopover = styled(Popover)(() => ({
  '& .MuiPopover-paper': {
    minWidth: 250,
  },
}));

export const MissingUserName = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
}));

export const UserMenuActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.625),
  padding: theme.spacing(1.75),
}));

export const UserMenuButton = styled(Button)(() => ({
  fontSize: 14,
}));

export const RebootIcon = styled(RotateLeftIcon)(({ theme }) => ({
  stroke: theme.palette.primary.main,
}));

export const PowerIcon = styled(PowerSettingsNewIcon)(({ theme }) => ({
  stroke: theme.palette.primary.main,
}));

export const LocalHostToggles = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export const LocalHostToggleRow = styled(Box)(() => ({}));

export const DialogTitleContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const DialogProgressTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isReboot',
})(({ isReboot }) => ({
  marginRight: isReboot ? 20 : 0,
  fontSize: isReboot ? 22 : 20,
}));

export const DialogIcon = styled(QuestionMarkIcon)(() => ({
  fontSize: 74,
}));

export const DialogWarningIcon = styled(PriorityHighIcon)(() => ({
  fontSize: 74,
}));
